import { h } from 'preact';
export const Info = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("circle", { cx: "12", cy: "12", r: "10" }),
        h("line", { x1: "12", y1: "16", x2: "12", y2: "12" }),
        h("line", { x1: "12", y1: "8", x2: "12.01", y2: "8" })));
};
//# sourceMappingURL=info.js.map